import NewsAlert from "./NewsAlert";
import Navbar from "./Navbar";

export default function SiteHeader() {
  return (
    <div className="sticky top-0 z-40">
      <NewsAlert />
      <Navbar />
    </div>
  );
}
